import { displayRate, displayTerm } from '../../../../util';
import {
  getScorecardElementValue,
  isScorecardTermElement,
  ScorecardElementSymbol,
  useScorecard,
} from '../../../../Scorecard';
import { useScoreHealthRangeValueItemPositioning } from './useScoreHealthRangeValueItemPositioning';
import { ScoreHealthRangeBreakpoint } from '../types';

interface UseScoreHealthRangeScoreIndicatorProps {
  householdID: string;
  numberOfSections: number;
  element: ScorecardElementSymbol;
  breakpoints: ScoreHealthRangeBreakpoint[];
}

export function useScoreHealthRangeScoreIndicator({
  element,
  breakpoints,
  householdID,
  numberOfSections,
}: UseScoreHealthRangeScoreIndicatorProps) {
  const { scorecard, scorecardQuery } = useScorecard({ householdID });
  const rangeValue = getScorecardElementValue(scorecard, element) || 0;
  const { leftStyle } = useScoreHealthRangeValueItemPositioning({ rangeValue, breakpoints, numberOfSections });

  const isLoading = scorecardQuery.isLoading;
  const scoreDisplay = isScorecardTermElement(element)
    ? displayTerm(rangeValue)
    : displayRate(rangeValue, { withSymbol: true });

  return { leftStyle, isLoading, scoreDisplay, element };
}
